(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-us-new"] && !Shopify.designMode) return;
  try {
    
    // tabs click event
    const tabs = document.querySelectorAll('.contact_us-tabs .tabs');
    const contact_dropdown__tigger = document.querySelector('.contact_dropdown__tigger .trigger__inner');
    const contact_us_mobile_tabs = document.querySelector('.contact_us_mobile_tabs');
    const tabs_radio = document.querySelectorAll('.contact_us_mobile_tabs input[type="radio"]');
    const overlay_div = document.querySelector('#minibag_mask');
    const active_overlay = document.querySelector('.minibag-mask.dropdown_active_mobile');
    const close_icon = document.querySelector('.contact_us_mobile_tabs .close_icon')

    tabs.forEach(function(e){
    e.addEventListener('click',function(event){
        const current_tab = event.currentTarget.dataset.tab;
        const allActiveEls = document.querySelectorAll('.active_tab');
        localStorage.setItem("currentTab", event.target.textContent);
        allActiveEls.forEach(el => el.classList.remove('active_tab'))
        event.currentTarget.classList.add('active_tab')

        const form_el = document.querySelectorAll('.contact_us_form_tabs .form__inner');

        if(contact_dropdown__tigger) {
        contact_dropdown__tigger.querySelector('p').innerHTML = event.target.innerHTML;
        document.querySelector(`.contact_us_mobile_tabs .tabs[data-tab="${current_tab}"] input`).click()
        }

        form_el.forEach(function(form){
        const form_name = form.dataset.form;

        if(event.currentTarget.dataset.tab == form_name) {
            form.classList.remove('hide_form_block')
        } else {
            form.classList.add('hide_form_block');
        }
        })
    })
    })

    if(contact_dropdown__tigger) {
    contact_dropdown__tigger.addEventListener('click',function(){
        contact_us_mobile_tabs.classList.add('active_dropdown');
        overlay_div.classList.add('dropdown_active_mobile');
        overlay_div.style.display = 'block';
        document.body.style.overflow = 'hidden'
    })
    }

    if(tabs_radio) {
    tabs_radio.forEach(function(input){
        input.addEventListener('change',function(e){
        const to_trigger_tab = e.target.parentElement.dataset.tab;
        const parent_tab_dropdown = e.target.closest('.contact_us_mobile_tabs')
        document.querySelector(`.tabs[data-tab="${to_trigger_tab}"]`).click();;
        contact_dropdown__tigger.querySelector('p').innerHTML = e.target.value;
        parent_tab_dropdown.classList.remove('active_dropdown')
        overlay_div.style.display = 'none';
        document.body.style.overflow = 'auto'
        })
    })
    }

    if(close_icon) {
    close_icon.addEventListener('click',function(){
        overlay_div.click()
    })
    }

    //check for active tab on reload
    let getCurrentTabValue = localStorage.getItem('currentTab').trim(' ');
    $(`.tabs[data-tab-title="${getCurrentTabValue}"]`).trigger('click');

    $('.hide_form_block .form_sucess').hide()


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-appointment-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {

    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            // console.log(text);
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;

              const recommendations_col_Swiper = new Swiper(".recommendations_col_Swiper", {
                navigation: false,
                slidesPerView: "auto",
                breakpoints: {
                  750: {
                    // Navigation arrows
                    navigation: {
                      nextEl: '.recommendations_col_Swiper .swiper-button-next',
                      prevEl: '.recommendations_col_Swiper .swiper-button-prev',
                    },
                  }
                },
              });


              document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
              window._swat.initializeActionButtons('.product-recommendations', '.swym-button');

            }


          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();
})();
